import _ from 'lodash';

const LocalStorageHelper = {
	getEmail() {
		try {
			const jsonData = JSON.parse(localStorage.getItem('cso_transport_booking_app'));
			return jsonData.booker.email;
		} catch (e) {}
		return '';
	},
	getBookerId() {
		const jsonData = JSON.parse(localStorage.getItem('cso_transport_booking_app'));
		return jsonData.booker._id;
	},
	getBooker() {
		const jsonData = JSON.parse(localStorage.getItem('cso_transport_booking_app'));
		return jsonData.booker;
	},
	logout() {
		try {
			localStorage.removeItem('cso_transport_booking_app');
		} catch (e) {}
	}
};

export default LocalStorageHelper;
